import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const weight: AnswerPathTreeNode = { path: 'weight', nodeId: NodeIds.insuredWeight };
